import styled from "styled-components";

interface IMainButton {
  isLoading?: any;
}
export const MainButton = styled.button<IMainButton>`
  ${(props) => `
    background-color: ${props.theme.colors.accentGreen};
    cursor: ${props.isLoading ? "not-allowed" : "pointer"};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  color: ${(props) => props.theme.colors.white};
  align-items: center;
  border: none;
  border-radius: 0.8rem;
  cursor: pointer;
  display: flex;
  font-size: 1.7rem;
  font-weight: 700;
  justify-content: center;
  margin-top: 1.5rem;
  min-height: 6rem;
  width: 40rem;

  &:disabled,
  &[disabled] {
    background-color: ${({ theme }) =>
      theme.colors.accentGreen + theme.transparencies.p20};
    cursor: not-allowed;
  }

  img {
    height: 3.5rem;
    margin-right: 1rem;
    width: 3.5rem;
  }
`;

export const CancelButton = styled(MainButton)`
  ${(props) => `
    background-color: ${props.theme.colors.white};
    color: ${props.theme.colors.accentRed};
    border: 1px solid ${props.theme.colors.accentRed};
  `}
  &:disabled,
  &[disabled] {
    background-color: ${(props) => props.theme.colors.white};
    cursor: not-allowed;
  }
`;

export const Container = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  align-items: center;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 5rem;
  scrollbar-width: none;
  width: 52rem;
  h1 {
    ${(props) => `
      color: ${props.theme.colors.blackTextBody};
      font-family: ${props.theme.fontFamilies.primaryFont};
    `}
    font-size: 2rem;
    font-weight: 800;
    margin-bottom: 3rem;
  }
  .row {
    background-color: ${(props) => props.theme.colors.white};
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.5rem;
    width: 40rem;
  }
  p {
    color: ${(props) =>
      props.theme.colors.blackTextTitle + props.theme.transparencies.p30};
    font-family: ${(props) => props.theme.fontFamilies.primaryFont};
    font-size: 1.5rem;
    font-weight: 500;
    margin: 0.5rem 0;
  }
  p.transport {
    ${(props) => `
      color: ${
        props.theme.colors.blackTextTitle + props.theme.transparencies.p58
      };
    `}
    font-size: 1.6rem;
    line-height: 2.4rem;
    padding: 0 1rem;
    text-align: center;
  }
  .p-value {
    color: ${(props) => props.theme.colors.blackTextTitle};
    font-weight: 700;
  }
  select {
    color: ${(props) => props.theme.colors.blackTextTitle};
    border-color: transparent;
    border-radius: 0.8rem;
    box-shadow: 0px 5px 30px rgb(231 231 234 / 62%);
    font-size: 1.4rem;
    font-weight: 600;
    height: 5rem;
    line-height: 1.7rem;
    padding-left: 1.5rem;
    width: 100%;
  }
  .vehicle-box {
    color: ${(props) => props.theme.colors.gray72};
    border: solid 1px;
    border-radius: 0.8rem;
    display: grid;
    grid-template-colums: 1fr;
    margin: 1.5rem 0 1.5rem;
    padding: 1rem;
  }

  .delete-vehicle {
    color: ${(props) => props.theme.colors.supportRed};
    font-family: ${(props) => props.theme.colors.primaryFont};
    align-items: center;
    cursor: pointer;
    display: flex;
    font-size: 1.2rem;
    font-weight: 600;
    justify-content: flex-end;
    margin-bottom: -0.5rem;
    margin-top: 2rem;
    text-align: end;
  }

  .delete-vehicle img {
    filter: invert(20%) sepia(50%) saturate(50) hue-rotate(672deg)
      brightness(90%) contrast(130%);
    height: 2.5rem;
    padding-right: 0.9rem;
    width: 2.5rem;
  }

  .request-options {
    display: flex;
    gap: 2rem;
  }
  .block-hint {
    color: ${(props) => props.theme.colors.red};
    font-size: 1.4rem;
    text-align: center;
  }
`;

export const Row = styled.div`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: center;
  display: flex;
  justify-content: space-between;

  h2 {
    ${(props) => `
      color: ${
        props.theme.colors.blackTextBody + props.theme.transparencies.p30
      };
    `}
    font-size: 1.2rem;
    font-weight: 700;
    margin: 0.5rem 0.5rem;
  }

  &.row-title {
    margin-top: 2rem;
  }

  .add-vehicle {
    color: ${(props) => props.theme.colors.blackTextBody};
    font-family: ${(props) => props.theme.colors.primaryFont};
    cursor: pointer;
    display: flex;
    font-size: 1.6rem;
    font-weight: 600;
  }
`;

export const WithdrawalByHandContainer = styled.div`
  align-items: center;
  color: ${(props) => props.theme.colors.blackTextBody};
  display: flex;
  font-family: ${(props) => props.theme.colors.primaryFont};
  font-size: 1.5rem;
  font-weight: 600;
  gap: 1rem;
  margin-top: 2rem;
`;

export const CheckBox = styled.input`
  cursor: pointer;
  height: 1.5rem;
  margin: 3rem;
  width: 1.5rem;
`;

interface IGrayBox {
  height?: string;
  disableOutline?: any;
  width?: string;
}
export const GrayBox = styled.div<IGrayBox>`
  ${(props) => `
    background-color: ${props.theme.colors.backgroundGray2};
    border: none;
    color: ${props.theme.colors.blackTextTitle};
    height: ${props.height ? props.height : "4.5rem"};
    outline: ${props.disableOutline ? "none" : ""};
    width: ${props.width};
  `}
  align-items: center;
  border-radius: 0.8rem;
  display: flex;
  font-size: 10.5px;
  font-weight: 500;
  padding: 1.5rem;
`;

export const ButtonContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  justify-content: flex-end;
  padding: 2rem;
  width: 100%;
  :disabled,
  [disabled] {
    background-color: ${(props) =>
      props.theme.colors.accentGreen + props.theme.transparencies.p20};
  }
`;
